import React from 'react';
import Blog2 from '../../containers/BlogContainers/Blog2';
import PageHeader from '../Shared/PageHeader';

const BlogClassic = () => {
    return (
        <div>
            <PageHeader title="Blog Classic" />
            <Blog2 />
        </div>
    );
};

export default BlogClassic;